const config = {
  apiBaseUrl: process.env.REACT_APP_BOBYMAPPR_API,
};
export default config;
